import React from "react"

const WrapperBetby = ({ children }: { children: any }) => {
  return (
    <>
      <div
        className={`w-full flex justify-center mt-70`}
      >
        <div className="w-full">{children}</div>
      </div>
    </>
  )
}

export default WrapperBetby
